import React from 'react';

import { Link } from 'react-router-dom';

import ArrowRightIcon from '@/assets/icons/arrow-right.svg?react';
import useModal from '@/hooks/common/useModal';
import { type RelatedParent, type Student } from '@/interfaces/student';

import styles from './ParentProfileV2.module.scss';

interface Props {
  parents: RelatedParent[];
  student: Student;
  currentUserId?: number;
}

const RelatedParentsCard: React.FC<Props> = ({
  parents,
  student,
  currentUserId,
}) => {
  const { showModal } = useModal();
  const showUnlink = parents.length > 1;
  const hasReachedParentsLimit =
    student.max_parents_count != null &&
    parents.length >= student.max_parents_count;

  const handleUnlinkClick =
    (parent: RelatedParent) => (e: React.MouseEvent<HTMLAnchorElement>) => {
      e.preventDefault();
      if (parent.id === currentUserId) {
        showModal('UnlinkSelfConfirmModal', {
          studentName: student.name,
          parentId: parent.id,
          code: student.code,
        });
      } else {
        showModal('UnlinkOtherParentConfirmModal', {
          parentName: `${parent.last_name}${parent.first_name}`,
          parentId: parent.id,
          code: student.code,
        });
      }
    };

  return (
    <div className={styles.ParentProfileV2__RelatedParentsCard}>
      <div className={styles.ParentProfileV2__RelatedParentsCard__Title}>
        紐付く保護者
        {student.max_parents_count != null && (
          <div className={styles.ParentProfileV2__RelatedParentsCard__Limit}>
            （最大{student.max_parents_count}人）
          </div>
        )}
      </div>
      <div
        className={styles.ParentProfileV2__RelatedParentsCard__ParentsComponent}
      >
        {parents.map((parent) => (
          <div
            key={parent.id}
            className={styles.ParentProfileV2__RelatedParentsCard__Parents}
          >
            <div>
              {parent.last_name}
              {parent.first_name}
            </div>
            {showUnlink && (
              <Link
                to="#"
                className={styles.ParentProfileV2__RelatedParentsCard__Unlink}
                onClick={handleUnlinkClick(parent)}
              >
                解除
              </Link>
            )}
          </div>
        ))}
        {!hasReachedParentsLimit && (
          <Link
            to={`/mypage/invite/${student.code}`}
            className={
              styles.ParentProfileV2__RelatedParentsCard__InvitationLink
            }
          >
            他の保護者を招待
            <ArrowRightIcon
              className={styles.ParentProfileV2__RelatedParentsCard__Icon}
            />
          </Link>
        )}
      </div>
    </div>
  );
};

export default RelatedParentsCard;
